// extracted by css-extract-rspack-plugin
module.exports =  {"liveNowIcon":"smmjr"};